import React from "react";
import { useState, useEffect, useContext } from "react";
import Navbar from "../../components/NavBar/Navbar";
import Footer from "../../components/Footer/Footer";
import "./blogDetail.css";
import blogimg from "../../images/blogimg.png";
import fb from "../../images/About_US/fb.svg";
import instaicon from "../../images/instalogo.svg";
import linkedin from "../../images/linkedin.svg";
import { useLocation } from "react-router-dom";
import ScrollTop from "../../components/ScrollToTop/ScrollTop";
import CreateWhatsappChatWidget from "../../components/WhatsAppIcon";
// import BlogIdContext from "../../Context/BlogIdContext";
// import ReactQuill from "react-quill";

function BlogDetail(props) {
  const [blog, setBlog] = useState();

  let location = useLocation();

  const listenScrollEvent = () => {
    window.scrollY > 100
      ? (document.getElementById("return-to-top").style.display = "grid")
      : // setnavColor("#252734")
        (document.getElementById("return-to-top").style.display = "none");
  };
  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);

  useEffect(() => {
    fetch(`/blogs/${location.state}`)
      .then((res) => res.json())
      .then((res) => setBlog(res));
  }, []);

  if (blog) {
    // console.log(blog.blogImage.path);
    const blogImagePath = blog.blogImage.path;
    const newBlogImagePath = blogImagePath.replace(/\s/g, "+");
    // console.log(
    //   `https://skylark-website-images.s3.ap-south-1.amazonaws.com/blog-images/${newBlogImagePath}`
    // );

    document.getElementById(
      "blog_header"
    ).style.backgroundImage = `url(https://skylark-website-images.s3.ap-south-1.amazonaws.com/blog-images/${newBlogImagePath})`;
  }

  var url =
    "https://wati-integration-service.clare.ai/ShopifyWidget/shopifyWidget.js?3023";
  var s = document.createElement("script");
  s.type = "text/javascript";
  s.async = true;
  s.src = url;
  var options = {
    enabled: true,
    chatButtonSetting: {
      backgroundColor: "#4dc247",
      ctaText: "",
      borderRadius: "25",
      marginLeft: "0",
      marginBottom: "50",
      marginRight: "50",
      position: "right",
    },
    brandSetting: {
      brandName: "SKYLARK",
      brandSubTitle: "Typically replies within a day",
      brandImg:
        "https://skylark-website-images.s3.ap-south-1.amazonaws.com/logo_res.png",
      welcomeText: "Hi there!\nHow can I help you?",
      messageText:
        "Hello team SKYLARK, I have an upcoming event.\nWhen can we schedule a meeting to discuss the details and requirements?",
      backgroundColor: "#8e0405",
      ctaText: "Start Chat",
      borderRadius: "25",
      autoShow: false,
      phoneNumber: "916201811075",
    },
  };
  s.onload = function () {
    CreateWhatsappChatWidget(options);
  };
  var x = document.getElementsByTagName("script")[0];
  x.parentNode.insertBefore(s, x);

  return (
    <div className="page_container">
      <div className="blogdetail_page_header">
        <Navbar />
      </div>
      <ScrollTop />

      <div className="blogDetail_container">
        <div className="blog_header" id="blog_header">
          <div className="blog_header_content">
            <p className="blog_title">{blog ? blog.title : ""}</p>

            <div className="author_date">
              <p className="blog_author">{blog ? blog.author : ""}</p>

              <p className="blog_date">
                {blog ? new Date(blog.createdAt).toDateString() : ""}
              </p>
            </div>
          </div>
        </div>

        <div className="blog_content_container">
          {/* {blog ? (
            <img
              className="blog_bg_image"
              src={
                blog.blogImage
                  ? `https://freelance-project-1-bucket.s3.ap-south-1.amazonaws.com/blog-images/${blog.blogImage.path}`
                  : blogimg
              }
            />
          ) : null} */}
          {/* <div className="blog_content">{blog ? blog.content : ""}</div> */}
          <div
            className="blog_content_"
            dangerouslySetInnerHTML={{ __html: blog ? blog.content : "" }}
          ></div>
        </div>

        <div className="blogdetail_bottom">
          {/* <div className="blog_alerts">
            <p className="text">Get Latest Blog Alerts </p>

            <div
              className="input_btn"
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <input className="blog_detail_email" type="text" />
              <button className="blogdetail_submit">Submit</button>
            </div>
          </div> */}

          <div className="social_icons">
            <p className="aboutus_follow">Follow Us</p>
            <p className="aboutus_updates"> To Get our Latest Updates </p>

            <div className="social_media_icons">
              <a href="https://www.facebook.com/info.skylarkevents/">
                {" "}
                <img src={fb} />
              </a>
              <a href="https://www.linkedin.com/company/skylark-events-decor/">
                <img src={linkedin} />
              </a>
              <a href="https://instagram.com/skylark.events_decor?igshid=YmMyMTA2M2Y=">
                <img src={instaicon} />
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default BlogDetail;
